import React from "react";
import "./Share_Btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Share_Btn = ({ faIcon, text = "Share", productUrl, productName }) => {
  const handleShare = () => {
    const url = productUrl || window.location.href;
    const title = productName || document.title;

    if (navigator.share) {
      // Native share (mobile + some desktop browsers)
      navigator
        .share({
          title: title,
          text: `Check out this product: ${title}`,
          url: url,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      // Fallback: Open social share links (example: WhatsApp)
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        `Check out this product: ${title} - ${url}`
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  return (
    <div className="Share_Btn" onClick={handleShare}>
      <div className="icon_holder">
        <p>
          <FontAwesomeIcon icon={faIcon} className="icon_class" />
        </p>
      </div>
    </div>
  );
};

export default Share_Btn;

// import React from 'react'
// import "./Share_Btn.css";
// import { faShareNodes } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// const Share_Btn = ({faIcon, text}) => {
// return (
//     <div className='Share_Btn'>
//         <div className='icon_holder'>
//            <p><FontAwesomeIcon icon={faIcon} className='icon_class'/> {text}</p>
//         </div>
//     </div>
// )
// }

// export default Share_Btn
